module.exports = __webpack_public_path__ + "img/covid oon deep oce.65143f58.jpg";